import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    LegalPageContainer,
    BackButton,
    LegalHighlightBox,
    LegalSection,
    ContactBox
} from '../../styles/legal/LegalShared.styles';
import { SupportGrid, SupportCard, FaqSection, FaqItem } from '../../styles/legal/Support.styles';
import { useSEO } from '../../hooks';

export const Support: React.FC = () => {
    const navigate = useNavigate();

    useSEO({
        title: 'Support | Plenty of Hearts',
        description: 'Get help with your Plenty of Hearts account — FAQs, contact info, and support resources.',
        canonical: '/support',
    });

    return (
        <LegalPageContainer>
            <div style={{ maxWidth: '800px', margin: '0 auto' }}>
                <BackButton onClick={() => navigate('/')}>
                    ← Back to App
                </BackButton>

                <h1>How can we help?</h1>
                <p style={{ textAlign: 'center', fontSize: '1.2em', marginBottom: '40px' }}>
                    Find answers to common questions or get in touch with our team.
                </p>

                <SupportGrid>
                    <SupportCard>
                        <span className="icon">👤</span>
                        <h3>Account & Profile</h3>
                        <p>Manage your settings, photo uploads, and personality assessments.</p>
                    </SupportCard>
                    <SupportCard>
                        <span className="icon">⭐</span>
                        <h3>Premium Features</h3>
                        <p>Information about subscriptions, billing, and exclusive features.</p>
                    </SupportCard>
                    <SupportCard>
                        <span className="icon">🛡️</span>
                        <h3>Safety & Privacy</h3>
                        <p>Tips for safe dating, reporting users, and data protection.</p>
                    </SupportCard>
                    <SupportCard>
                        <span className="icon">⚙️</span>
                        <h3>Technical Support</h3>
                        <p>Troubleshooting app issues, notifications, and device compatibility.</p>
                    </SupportCard>
                </SupportGrid>

                <FaqSection>
                    <h2>Frequently Asked Questions</h2>

                    <FaqItem>
                        <h4>How does the personality matching work?</h4>
                        <p>We use a unique 8-question assessment based on psychology to determine your "Heart Type". We then match you with users whose types complement yours for better long-term compatibility.</p>
                    </FaqItem>

                    <FaqItem>
                        <h4>Is Plenty of Hearts free to use?</h4>
                        <p>Yes. Creating a profile, taking the personality quiz, matching, messaging through Message Bets and taking part in every chat room are all free, along with 10 swipes a day, 3 photos and a profile video. Premium and Premium Plus raise those limits, let you message anyone, and — on Premium Plus — let you create your own chat rooms.</p>
                    </FaqItem>

                    <FaqItem>
                        <h4>How do I report a suspicious profile?</h4>
                        <p>On any user's profile, scroll to the bottom and tap "Report User". Our safety team reviews all reports within 24 hours.</p>
                    </FaqItem>

                    <FaqItem>
                        <h4>Can I change my personality quiz results?</h4>
                        <p>You can retake the quiz once every 30 days. We find that personality preferences remain stable, but we allow updates as you grow.</p>
                    </FaqItem>
                </FaqSection>

                <ContactBox>
                    <h2>Still need help?</h2>
                    <p>Our support team is available Monday through Friday, 9:00 AM to 6:00 PM EST.</p>

                    <div className="methods">
                        <div className="method">
                            <span>Email Support</span>
                            <a href="mailto:support@plentyofhearts.com">support@plentyofhearts.com</a>
                        </div>
                        <div className="method">
                            <span>Help Center</span>
                            <a href="#">View Documentation</a>
                        </div>
                    </div>
                </ContactBox>

                <div style={{ textAlign: 'center', color: '#8e9aaf', fontSize: '0.9em', marginTop: '60px' }}>
                    © 2026 Plenty of Hearts Support Center. All rights reserved.
                </div>
            </div>
        </LegalPageContainer>
    );
};
